import React from 'react';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export default function PermissionsItem({ expanded, section, openAccordion }) {
    let showReadHeader = Object.keys(section.content).some((key) => section.content[key][section.title] === 'read');
    let showReadWriteHeader = Object.keys(section.content).some((key) => section.content[key][section.title] === 'read/write');
    
    const styles = {
        buttonRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            marginBottom: 20
        },
        block: {
            flex: 1,
            padding: 10
        },
        panelDetails: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            padding: '0 20px 0 0'
        },
        expanded: {
            "&$expanded": {
                '&>:last-child': {
                    color: `${ Theme.colors.mainTextGrey } !important`,
                    fontSize: 16,
                    fontWeight: '500 !important',
                    marginRight: '-12px !important'
                },
                backgroundColor: Theme.colors.surface,
                minHeight: '24px !important',
                margin: '0 !important'
            }
        },
        root: {
            paddingLeft: 0,
            paddingRight: 0,
            minHeight: '50px !important',
            borderBottomWidth: 1,
            borderBottomColor: Theme.colors.lightGrey,
            borderBottomStyle: 'solid'
        },
        panelSpare: {
            height: 48,
            cursor: 'default',
            backgroundColor: Theme.colors.surface
        },
        row: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        title: {
            flex: 1
        },
        accordionSummary: {
            "& .MuiAccordionSummary-expandIconWrapper": {
                color: Theme.colors.mainTextGrey,
                width: 24,
                height: 24,
                padding: 3,  
                justifyContent: "center",
                alignItems: "center"
            },
            '& .MuiAccordionSummary-expandIconWrapper:hover': {
                backgroundColor: "#bfbfbf",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%"
            },
            '&.MuiAccordionSummary-root': {
                borderColor: "#e6e7e8",
                borderBottomStyle: "solid",
                borderBottomWidth: "1px"
            }
        }
    };

    return (
        <div style={ styles.block }>
            <Accordion
                square
                onChange={openAccordion(section.title)}
                style={{ boxShadow: 'none' }}
            >
                <AccordionSummary
                    classes={{
                        content: styles.panelsection,
                        expanded: styles.expanded,
                        root: styles.root
                    }}
                    sx={ styles.accordionSummary}
                    expandIcon={expanded.includes(section.title) ? <RemoveIcon /> : <AddIcon />}
                >
                    <Text id={section.title} medium bold>{section.title}</Text>
                </AccordionSummary>
                <AccordionDetails style={styles.panelDetails}>
                    { showReadHeader &&
                        <Text
                            small
                            bold
                            margin="20px 0px 10px 0px"
                            color={ Theme.colors.skyBlue }
                        >
                            Read
                        </Text>
                    }

                    <div style={styles.row}>
                        {
                            Object.keys(section.content).map((key) => {
                                if (section.content[key][section.title] === 'read') {
                                    return (
                                        <Text key={key} tiny margin="5px">
                                            {key}
                                        </Text>
                                    );
                                }

                                return null;
                            })
                        }
                    </div>

                    { showReadWriteHeader &&
                        <Text
                            small
                            bold
                            margin="20px 0px 10px 0px"
                            color={ Theme.colors.skyBlue }
                        >
                            Read & Write
                        </Text>
                    }

                    <div style={styles.row}>
                        {
                            Object.keys(section.content).map((key) => {
                                if (section.content[key][section.title] === 'read/write') {
                                    return (
                                        <Text key={key} tiny margin="5px">
                                            {key}
                                        </Text>
                                    );
                                }

                                return null;
                            })
                        }
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}